// Libraries
import React from 'react'

// Styles
import { Wrap, ContentWrap, WrapLink, Text, Hr, SmallText, Vertical, FooterLogo } from './style'
import { Link } from '../../ui/Link'


export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <Wrap>
      <ContentWrap>
        <FooterLogo alt='wheel' src='/footer_logo.svg'
                    whileHover={{
                      rotateZ: ['0', '-75deg', '90deg'],
                      transition: { duration: 2 },
                    }}
                    whileTap={{ scale: 0.9 }}/>
        <SmallText>Morbi sed bibendum ut commodo lorem. Viverra malesuada sit sed ut amet quam mi. Arcu vivamus amet, ac quam viverra sapien ac posuere semper. Massa elementum libero lacus, volutpat vestibulum, orci id orci.</SmallText>
        <Hr/>
        <WrapLink>
          <Link href='https://99chartertipps.yachtcharterfinder.com/imprint' target="_blank">Impressum</Link>
          <Vertical />
          <Link href='https://99chartertipps.yachtcharterfinder.com/data-protection' target="_blank">Datenschutz</Link>
        </WrapLink>
        <Text>Urheberrechte {year} - <Link href='https://www.yachtcharterfinder.com/' target='_blank'>www.yachtcharterfinder.com</Link> Alle Rechte vorbehalten</Text>
      </ContentWrap>
    </Wrap>
  )
}
